module.exports = "jQuery(document).ready(function() {\n\t\n\tvar staticPage = $('.static-content-page').not('.workshop-template');\n\tvar panel = $(staticPage).find('#main-container .panel .panel-heading');\n\t// Override Bootstrap accordion panel behavior as they were missused here.\n\t$(panel).on('click', function(event) {\n\t\tevent.preventDefault();\n\t\tevent.stopPropagation();\n\t\tjQuery(this).find('a').toggleClass('collapsed');\n\t\tjQuery(this).parent().find('.panel-collapse').toggleClass('in');\n\t});\n\t\n});"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/legacy/pages/static-content.legacy.js
// module id = 669
// module chunks = 31